/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* TODO:
 * Implement jwPlayerObject event updating as a service
 * Other component can listen to this service and act accordingly
 *  - i.e. overlay, logging etc
 */
/* TODO: [Check eslint output]
 * - Remove console log
 * - Fix unnamed function
 * - Remove unused jwplayerObject
 * - Remove unused overlayRight
 */
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import { Model } from '@viddsee/server-api-client';

import urlLocationHelper from '@/scripts/helpers/url-location-helper';
import BrowserDetector from '@/scripts/helpers/browser-detector';
import BrowserStorage from '@/scripts/helpers/browser-storage';
import webcall from '@/scripts/webcall';
import viddsee from '@/scripts/viddsee';
import analytic, { getAnalyticPayload } from '../analytic';

import VideoTracker from './tracker';
import sourceGenerator, { GeneratedVideoSourcePayloadSourceMeta, GeneratedVideoSourcePayload } from './sourceGenerator';

import jwplayer from './jwplayer-importer';
import { VideoPagePlayerOptions, TrackerTrackEventName } from '@/scripts/models/VideoPagePlayerOptions';
import { Nullable } from '@/scripts/models/utility-types';

interface ThisVideoProp extends Model.Video.Info {
  source?: GeneratedVideoSourcePayloadSourceMeta['source'];
}

interface ThisVideoPagePlayerOptions extends VideoPagePlayerOptions {
  hosted?: string | 'true';
}

interface LegacyVideoPlayerOptions {
  videoTracker?: VideoTracker;
  video?: ThisVideoProp;
  playerOptions?: ThisVideoPagePlayerOptions;
  element: {
    id: string;
    height: string;
    width: string;
  };
  player: {
    animating: boolean;
    debug: boolean;
    firstShowDownloadInfoTimeout: Nullable<number>;
    goneIntoFallback: boolean;
    overlayTimeOut?: number;
    advertising: any;
  };
}

const options: LegacyVideoPlayerOptions = {
  element: {
    id: 'video__object__player__video-player',
    height: '100%',
    width: '100%',
  },
  player: {
    animating: false,
    debug: false,
    firstShowDownloadInfoTimeout: null,
    goneIntoFallback: false,
    // overlayTimeOut: null,
    // shownBufferMessage: false,
    // hasShownOverlayAppGate: false,
    advertising: {},
  },
};

let $player: JQuery;
let $cover: JQuery;
let $coverActions: JQuery;
let $playBtn: JQuery;
let $overlayAgeGate: JQuery;
let $overlayAppGate: JQuery;
let $overlayDownload: JQuery;
let $overlayError: JQuery;
let $overlayPause: JQuery;
let jwplayerObject: jwplayer.JWPlayer;
const jwplayerObjectNotifier = {
  value: null as jwplayer.JWPlayer | null,
  _listener: {
    _events: [] as any[],
    on: (cb: any) => {
      jwplayerObjectNotifier._listener._events.push(cb);
    },
    dispatch: () => {
      const toProcess = [...jwplayerObjectNotifier._listener._events];
      jwplayerObjectNotifier._listener._events = [];
      toProcess.forEach(cb => cb());
    },
  },
  set(value: jwplayer.JWPlayer) {
    jwplayerObjectNotifier.value = value;
    jwplayerObjectNotifier._listener.dispatch();
  },
  get() {
    return new Promise((resolve) => {
      jwplayerObjectNotifier._listener.on(() => {
        resolve(jwplayerObjectNotifier.value);
      });
    });
  },
};

const _continuePlay = function _continuePlay() {
  _hideOverlayAppGate();

  jwplayerObject.play(true);
  options.videoTracker!.track(TrackerTrackEventName.ContinuePlay);
};

const _firstPlay = function _firstPlay($this: JQuery) {
  _hideCover();

  // Hide title, logo, actionbar
  $('.video__object__player__cover__embed-info').css('display', 'none');
  $('.video__object__player__cover__logo').css('display', 'none');
  $coverActions.css('display', 'none');

  const isAndroidNotTwitterWebView = (BrowserDetector.os() === 'AndroidOS') && !BrowserDetector.isTwitter();
  const isIphone = (BrowserDetector.os() === 'iOS') && (BrowserDetector.md().phone() === 'iPhone');

  // On mobile browser (except for Android's Twitter in app browser and iPad)
  if (isAndroidNotTwitterWebView || isIphone) {
    const referrer = options.playerOptions!.parent_url;
    const isThirdParty = [
      'starfish.viddsee.com',
      'buzz.viddsee.com',
      'strawberry.viddsee.com',
    // return true if every url is not matched
    ].every(url => referrer!.indexOf(url) === -1);

    if (isThirdParty) {
      jwplayerObject.play(true);
    } else {
      // display app gate
      _showOverlayAppGate();
    }

    // On Android browser (except for Twitter in app browser), open video deep link, if available
    if (isAndroidNotTwitterWebView) {
      options.videoTracker!.track(TrackerTrackEventName.ClickPlay);

      if ($playBtn.data('url-android')) {
        window.open($this.data('url-android'));
        return false;
      } else {
        _log('No deep URL to Android app');
      }
    }
  } else {
    jwplayerObject.play(true);
  }

  options.videoTracker!.track(TrackerTrackEventName.FirstPlay);

  const now = new Date();
  BrowserStorage.setItem('last_watched', `${now}`);
};

const _goIntoHostedFallback = async function _goIntoHostedFallback() {
  _log('_goIntoHostedFallback');

  try {
    const data = await webcall.video.getHostedSources({
      video_id: options.video!.id,
      page_token: options.playerOptions!.page_token,
    });

    _log(data as any);
    const videoSourcePayload = sourceGenerator.generate(data as any, options.video!);
    _log(JSON.stringify(videoSourcePayload, null, 2));
    jwplayerObject.load([{
      sources: videoSourcePayload.sources,
      // NOTE: 2020Q1_REVAMP_NOTE (videoSourcePayload.subtitles) never existed, instead it has been renamed to tracks
      tracks: videoSourcePayload.tracks,
    }]);
    // jwplayerObject.play(true)

    // Player Time
    options.videoTracker!.track(TrackerTrackEventName.GoIntoHostedFallback, {
      originalSource: options.video!.source,
    });
    options.video!.source = get(videoSourcePayload, 'sources[0].meta.source');
  } catch (error) {
    // TODO: Use a facade to log error
    window.Sentry && window.Sentry.captureException(error);
  }
};

const _hideCover = function _hideCover() {
  $cover.css('display', 'none');
};

const _hideOverlayAppGate = function _hideOverlayAppGate() {
  $overlayAppGate.addClass('hidden');
};

const _hideOverlayPause = function _hideOverlayPause() {
  $overlayPause.addClass('hidden');
};

const _initCoverActions = function _initCoverActions() {
  _log('_initCoverActions');

  if (!$coverActions) { return; }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  $coverActions.find('.js-video__heart').on('click', (_e) => {
    _log('.js-video__heart:click');

    // FIXME: Temporary for embed since no login option.
    const videoUrl = `https://www.viddsee.com/video/${options.video!.slug}/${options.video!.id}`;
    window.open(videoUrl);
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  $cover.find('.js-video__download__text').on('click', (_e) => {
    $('.video__object__actions__tooltip--download__text-app').removeClass('hidden');
  });
};

const _initSendToViddsee = function _initSendToViddsee() {
  $('.jw-button-container').append('<div class="jw-icon jw-icon-inline jw-button-color jw-reset jw-viddsee-logo"></div>');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  $('.jw-viddsee-logo').on('click', (_e) => {
    analytic.send(getAnalyticPayload(e => e.player['control-bar'].click['embed-viddsee-icon'], ''));
    const videoUrl = `https://www.viddsee.com/video/${options.video!.slug}/${options.video!.id}`;
    window.open(videoUrl, '_blank');
  });
};

const _initJWPlayer = function _initJWPlayer(videoSourcePayload: GeneratedVideoSourcePayload) {
  const advertisingMasterVideoTag = {
    // See documentation at: https://support.google.com/dfp_premium/answer/1068325?hl=en
    sz: '640x480',
    iu: '/119274074/Buzz-House-Preroll',
    ciu_szs: '',
    impl: 's',
    gdfp_req: 1,
    env: 'vp',
    output: 'xml_vast2',
    unviewed_position_start: 1,
    url: '[referral_url]', // Will be set by jwplayer
    correlator: '[timestamp]', // Will be set by jwplayer
    description_url: `https://www.viddsee.com/video/${options.video!.slug}/${options.video!.id}`,
  };

  options.player.advertising = {
    client: 'googima',
    admessage: '',
    tag: 'http://pubads.g.doubleclick.net/gampad/ads' + urlLocationHelper.query.encode(advertisingMasterVideoTag),
  };

  jwplayerObject = jwplayer(options.element.id);
  jwplayerObjectNotifier.set(jwplayerObject);

  return (Promise.resolve([videoSourcePayload])) // This logic doesn't work with falbacktoHostedSource yet
    .then((playlist) => {
      jwplayerObject.setup({
        flashplayer: '/js/jwplayer-7.2.2/jwplayer.flash.swf',
        width: options.element.width,
        height: options.element.height,
        autostart: false,
        abouttext: 'About Viddsee',
        aboutlink: 'https://www.viddsee.com',
        nextupoffset: options.video!.creditsStart
          // NOTE: 2020Q1_REVAMP_NOTE duraction_seconds was never sent down from embed player
          // NOTE: 2020Q1_REVAMP_NOTE This commit will pass durationSeconds into embed player
          ? options.video!.creditsStart - options.video!.durationSeconds
          : -10,
        playlist,
        advertising: options.player.advertising,
        cast: {},
      });
    })
    .then(() => {
      // Attach event listener to jwplayerObject
      jwplayerObject.on('buffer', _onBuffer);
      jwplayerObject.on('beforeComplete', () => {
        jwplayerObject.stop();
        setTimeout(() => {
          // Automatically move on the next video if user is viewing the player
          if ((jwplayerObject as any).getViewable()) {
            (jwplayerObject as any).next();
          }
        }, 1000);
      });
      jwplayerObject.on('complete', _onComplete);
      jwplayerObject.on('displayClick', _onDisplayClick);
      jwplayerObject.on('error', _onPlayerError);
      jwplayerObject.on('firstFrame', _onFirstFrame);
      jwplayerObject.on('levelsChanged', _onLevelsChanged);
      jwplayerObject.on('ready', _onReady);
      jwplayerObject.on('pause', _onPause);
      jwplayerObject.on('play', _onPlay);
      jwplayerObject.on('seek', _onSeek);
      jwplayerObject.on('seeked', _onSeeked);
      jwplayerObject.on('setupError', _onSetupError);
      jwplayerObject.on('time', throttle(_onTime, 500));
      jwplayerObject.on('captionsChanged', _onCaptionsChanged);
      jwplayerObject.on('playlistItem', (event) => {
        if (event.index !== 0) {
          jwplayerObject.stop();
          location.href = event.item.url;
        }
      });

      jwplayerObject.once(
        /*
          Definition in @types/jwplayer is outdated.
          It doesn't contain playAttemptFailed as of today
        */
        'playAttemptFailed' as any,
        () => {
          const isPreviouslyMuted = jwplayerObject.getMute();
          jwplayerObject.setMute(true);
          jwplayerObject.play(true);

          if (!isPreviouslyMuted) {
            setTimeout(() => {
              localStorage.removeItem('jwplayer.mute');
            });
          }
        },
      );

      if (options.playerOptions!.service_type === 'vimeo_mp4' || options.playerOptions!.service_type === 'hosted') {
        if (BrowserDetector.os() === 'AndroidOS') {
          $('.coverphoto').css('padding-top', 0);
        }
      }
      return jwplayerObject;
    });
};

const _initOverlayAgeGate = function _initOverlayAgeGate() {
  _log('_initOverlayAgeGate');

  $overlayAgeGate.on('click', '.video__object__player__overlay--age-gate__login', (e) => {
    // var $this = $(this)

    e.preventDefault();
    viddsee.ui.modal.register.open();
  });
};

const _initOverlayAppGate = function _initOverlayAppGate() {
  _log('_initOverlayAppGate');

  $overlayAppGate.on('click', '.video__object__player__overlay--app-gate__install-and-watch', (e) => {
    const $this = $(e.currentTarget);

    e.preventDefault();
    window.ga('send', 'event', 'app-campaign', 'player', options.video!.title);

    // Android
    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') { // iOS
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
    // $('.appgate-content').addClass('hidden');
    // $('.appgate-content--thankyou').removeClass('hidden');
    // $('.continue-play').removeClass('hidden');
  });

  $overlayAppGate.on('click', '.video__object__player__overlay--app-gate__open-in-app', (e) => {
    const $this = $(e.currentTarget);

    e.preventDefault();
    window.ga('send', 'event', 'deeplink', 'player', options.video!.title);

    // Android
    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') { // iOS
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
  });

  $overlayAppGate.on('click', '.video__object__player__overlay--app-gate__continue', () => {
    _continuePlay();
  });
};

const _initOverlayDownload = function _initOverlayDownload() {
  _log('_initOverlayDownload');

  $overlayDownload.on('click', '.video__object__player__overlay--download__install-and-download', (e) => {
    const $this = $(e.currentTarget);

    e.preventDefault();
    window.ga('send', 'event', 'app-campaign', 'player-download', options.video!.title);

    // Android
    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') { // iOS
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
  });

  $overlayDownload.on('click', '.video__object__player__overlay--download__download', (e) => {
    const $this = $(e.currentTarget);

    e.preventDefault();
    window.ga('send', 'event', 'deeplink', 'player-download', options.video!.title);

    // Android
    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') { // iOS
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
  });
};

const _initOverlayPause = function _initOverlayPause() {
  if (BrowserDetector.os() === 'AndroidOS') {
    $overlayPause.find('.overlay--pause__link-download').addClass('hidden');
    $overlayPause.find('.overlay--pause__link-download-android').removeClass('hidden');
    $overlayPause.find('.overlay--pause__link-download-ios').addClass('hidden');
    $overlayPause.find('.overlay--pause__link-watch-in-app').removeClass('hidden');
  } else if (BrowserDetector.os() === 'iOS') {
    $overlayPause.find('.overlay--pause__link-download').addClass('hidden');
    $overlayPause.find('.overlay--pause__link-download-android').addClass('hidden');
    $overlayPause.find('.overlay--pause__link-download-ios').removeClass('hidden');
    $overlayPause.find('.overlay--pause__link-watch-in-app').removeClass('hidden');
  }

  $overlayPause.on('click', '.overlay--pause__link-replay, .overlay--pause__link-resume', () => {
    _hideOverlayPause();
    jwplayerObject.play(true);
    options.videoTracker!.track(TrackerTrackEventName.PauseResume);
  });

  $overlayPause.on('click', '.overlay--pause__link-watch-in-app', (e) => {
    const $this = $(e.currentTarget);

    _log(BrowserDetector.os());

    if (BrowserDetector.os() === 'AndroidOS' && $this.data('href-android')) {
      window.open($this.data('href-android'));
    } else if (BrowserDetector.os() === 'iOS' && $this.data('href-ios')) {
      window.open($this.data('href-ios'));
    }
  });
};

// const _initBranchLinks = function _initBranchLinks() {
//   _log('_initBranchLinks');
//   // .video__object__player__overlay--app-gate__install-and-watch
//   window.branch.link({
//     channel: 'app-campaign',
//     feature: 'player',
//     tags: [options.video!.title],
//     data: {
//       $desktop_url: 'https://www.viddsee.com',
//       $deeplink_path: 'video/' + options.video!.id,
//     },
//   }, (err: any, link: any) => {
//     if (!err) {
//       $('.video__object__player__overlay--app-gate__install-and-watch')
//         .data('href-android', link)
//         .data('href-ios', link)
//       ;
//     }
//   });

//   // .video__object__player__overlay--app-gate__open-in-app
//   window.branch.link({
//     channel: 'deeplink',
//     feature: 'player',
//     tags: [options.video!.title],
//     data: {
//       $desktop_url: 'https://www.viddsee.com',
//       $deeplink_path: 'video/' + options.video!.id,
//     },
//   }, (err: any, link: any) => {
//     if (!err) {
//       $('.video__object__player__overlay--app-gate__open-in-app')
//         .data('href-android', link)
//         .data('href-ios', link)
//       ;
//     }
//   });

//   // .video__object__player__overlay--download__install-and-download
//   window.branch.link({
//     channel: 'app-campaign',
//     feature: 'player-download',
//     tags: [options.video!.title],
//     data: {
//       $desktop_url: 'https://www.viddsee.com',
//       $deeplink_path: 'download/' + options.video!.id,
//     },
//   }, (err: any, link: any) => {
//     if (!err) {
//       $('.video__object__player__overlay--download__install-and-download')
//         .data('href-android', link)
//         .data('href-ios', link)
//       ;
//     }
//   });

//   // .video__object__player__overlay--download__download
//   window.branch.link({
//     channel: 'deeplink',
//     feature: 'player-download',
//     tags: [options.video!.title],
//     data: {
//       $desktop_url: 'https://www.viddsee.com',
//       $deeplink_path: 'download/' + options.video!.id,
//     },
//   }, (err: any, link: any) => {
//     if (!err) {
//       $('.video__object__player__overlay--download__download')
//         .data('href-android', link)
//         .data('href-ios', link)
//       ;
//     }
//   });

//   // .js-unsupported-download-app link
//   window.branch.link({
//     channel: 'app-campaign',
//     feature: 'opera',
//     tags: [options.video!.title],
//     data: {
//       $desktop_url: 'https://www.viddsee.com',
//       $deeplink_path: 'video/' + options.video!.id,
//     },
//   }, (err: any, link: any) => {
//     if (!err) {
//       $('.js-unsupported-download-app')
//         .data('href-android', link)
//         .data('href-ios', link)
//       ;
//     }
//   });
// };

const _initEvents = function _initEvents() {
  $player.on('vs:ui:video:player:pause', (state) => {
    if (state) {
      if (jwplayerObject.getState() !== 'idle') {
        // NOTE: 2020Q1_REVAMP_NOTE This state should be a boolean, from
        // NOTE: 2020Q1_REVAMP_NOTE https://github.com/viddsee/viddsee-api/blob/a4be35fc2/app/javascript/scripts/Components/Organisms/Video/VideoActions/legacy-ui/action-bar.js#L102
        jwplayerObject.pause(state as unknown as boolean);
      }
    } else {
      jwplayerObject.pause();
    }
  });

  $player.on('click', '.video__object__player__play', (e) => {
    _firstPlay($(e.currentTarget));
  });

  // Action Bar - Heart
  // TODO: Tracking https://github.com/viddsee/viddsee_api/issues/567
  // This methods should be migrated to video action and reimpleemnt with action module
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  $player.on('vs:ui:player:heart', (e, _callback) => {
    let increment = false;
    const counter = $('.video__object__actions__heart a');
    let totalHearts = $('.video__object__actions__heart a').data('total-hearts');
    // var videoTitle = $('.video__object__actions__heart a').data('video-title')

    if (counter.hasClass('selected')) {
      increment = false;
      totalHearts -= 1;
      window.ga('send', 'event', 'video', 'unlike', options.video!.title);
    } else {
      increment = true;
      totalHearts += 1;
      window.ga('send', 'event', 'video', 'like', options.video!.title);
      // window.Intercom('trackEvent', 'video-like');
    }

    $('.video__object__actions__heart a').data('total-hearts', totalHearts);
    let value = totalHearts;
    if (totalHearts > 1000) {
      value = totalHearts / 1000.0;
      value = value.toFixed(1);
      value = value + 'k';
    }
    counter.children('span').html('<span class="md-heart"></span> ' + value);

    const opts = {
      rating_id: 'rating_like',
      video_id: options.video!.id,
      params: {
        rating_like: (increment) ? 1 : 0,
      },
    };
    webcall.postUserVideoRating(opts, () => {
      // $(e.target).trigger('vs:ui:video.action_bar:heart:toggle', increment)
      $(e.target).addClass('video__object__player__cover__actions__btn--selected');
    });
  });
};

const _initBuzzEventListener = function _initBuzzEventListener() {
  window.addEventListener('message', (event) => {
    // event.data is the information received from the postMessage
    // event.data.trigger is a custom trigger sent together with the postMessage
    // if (event.origin !== "http://buzz.viddsee.com")
    // return;
    if (event.data.trigger === 'playVideo') {
      // Triggers the play video
      // if(! BrowserStorage.getItem('access_token') && video.hasContentRating) {
      //  return false;
      // }
      if (
        (BrowserDetector.os() === 'AndroidOS') ||
        (BrowserDetector.os() === 'iOS' && BrowserDetector.md().phone() === 'iPhone')
      ) {
        _log('_initBuzzEventListener: isMobile');
      } else {
        _log('_initBuzzEventListener: !isMobile');
        $('.video__object__player__play').click();
        (window as any)['embedPlayInitiated'] = true;
      }
    } else if (event.data.trigger === 'pauseVideo') {
      jwplayerObject.pause(true);
    }
  }, false);
};

const _log = function _log(log: string) {
  // TODO: Use a centralized debugger
  // eslint-disable-next-line no-console
  if (options.player.debug) { console.log(log); }
};

const _onBuffer = function _onBuffer(event: any) {
  _log('_onBuffer');
  $player.trigger('vs:ui:video:player:jwplayer:buffer', [event]);
};

const _onComplete = function _onComplete() {
  _log('_onComplete');
  $player.trigger('vs:ui:video:player:jwplayer:complete');

  if (BrowserDetector.os() === 'iOS' && BrowserDetector.version('iOS') <= 7) {
    $('.jw-video').hide();
  }
  _showOverlayPause(true);
};

const _onDisplayClick = function _onDisplayClick() {
  const overlayRight = $('.next-up').css('right');

  _log('_onDisplayClick');
  $player.trigger('vs:ui:video:player:jwplayer:displayClick');

  if (!options.player.animating && overlayRight === '0px') {
    window.clearTimeout(options.player.overlayTimeOut as number);
    $('.next-up').toggleClass('tapped');
    if ($('.next-up').hasClass('tapped')) {
      options.player.overlayTimeOut = window.setTimeout(() => {
        $('.next-up').removeClass('tapped');
      }, 4000);
    }
  }
};

const _onFirstFrame = function _onFirstFrame(event: any) {
  _log('_onFirstFrame');
  $player.trigger('vs:ui:video:player:jwplayer:firstFrame', [event]);
  if (options.video!.source === 'hosted') {
    analytic.send({
      category: 'video',
      label: options.video!.id,
      customProperties: {
        snowplow: {
          action: 'failover',
        },
      },
    });
  }
  if (BrowserDetector.os() === 'AndroidOS' || BrowserDetector.os() === 'iOS') {
    options.player.firstShowDownloadInfoTimeout = window.setTimeout(() => {
      options.player.firstShowDownloadInfoTimeout = null;
    }, 5000);
  }
};

const _onLevelsChanged = function _onLevelsChanged() {
  _log('_onLevelsChanged');
  $player.trigger('vs:ui:video:player:jwplayer:levelChanged');
};

// NOTE: 2020Q1_REVAMP_NOTE pauseReason is not defined in the type definition of @types/jwplayer
// NOTE: 2020Q1_REVAMP_NOTE it likely neer exist
const _onPause = function _onPause(event: /* { pauseReason: string } */ any) {
  if (event.pauseReason !== 'interaction') {
    return;
  }

  _log('_onPause');
  $player.trigger('vs:ui:video:player:jwplayer:pause', [event]);

  $('.video__object__player__cover__embed-info').css('display', 'block');
  // $('.video__object__player__cover__logo').css('display', 'block')
  $coverActions.css('display', 'block').css('bottom', '12%');

  // Temporary fix for #332.
  // Ensure click event finished its propagation so that overlay does not
  // intercepting this 'click' event
  setTimeout(() => {
    _showOverlayPause();
  }, 0);
};

const _onPlay = function _onPlay(event: any) {
  const overlayRight = $('.next-up').css('right');

  _log('_onPlay');
  $player.trigger('vs:ui:video:player:jwplayer:play', [event]);

  _hideCover();
  _hideOverlayPause();

  $player.addClass('video__object__player--played');

  // Backward compatibility
  // <= iOS 7: Allow video to be played
  $player.find('.jw-video').show();

  if (options.player.firstShowDownloadInfoTimeout == null) {
    // $('.download-info').hide();
  }
  if (!options.player.animating && overlayRight === '0px') {
    window.clearTimeout(options.player.overlayTimeOut as number);
    $('.next-up').removeClass('tapped');
  }
  $('.related-videos-wrapper').css('display', 'none');

  $('.video__object__player__cover__embed-info').css('display', 'none');
  $('.video__object__player__cover__logo').css('display', 'none');
  $coverActions.css('display', 'none');
};

const _onPlayerError = function _onPlayerError(event: { message: any }) {
  _log('_onPlayerError');
  $player.trigger('vs:ui:video:player:jwplayer:playerError', [event]);
  _log(event.message);

  if (!options.player.goneIntoFallback && options.video!.source !== 'hosted') {
    options.player.goneIntoFallback = true;
    _goIntoHostedFallback();
  }
};

const _onReady = function _onReady() {
  _log('_onReady');
  $player.trigger('vs:ui:video:player:jwplayer:ready');

  if (BrowserDetector.os() === 'iOS' && BrowserDetector.version('iOS') <= 7) {
    $('.jw-video').hide();
  }

  if (BrowserDetector.os() === 'AndroidOS' || BrowserDetector.os() === 'iOS') {
    $('.masthead-player .coverphoto').css('display', 'block');
  }

  $('.jw-controlbar-right-group').append('<div class="jw-icon jw-icon-inline jw-button-color jw-reset jw-viddsee-logo"><img src="/images/player/logo.png"></div>');
  $('.jw-icon-hd').tooltip({
    placement: 'top',
    title: 'Slow connection? Switch to LO for a better viewing experience',
    trigger: 'manual',
  });

  $('.masthead-player').addClass('masthead-player--loaded');

  _initEvents();
  _initBuzzEventListener();

  _initCoverActions();
  _initOverlayAgeGate();
  _initOverlayAppGate();
  _initOverlayDownload();
  _initOverlayPause();
  _initSendToViddsee();
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _onSeek = function _onSeek(_event: any) {
  _log('_onSeek');
  $player.trigger('vs:ui:video:player:jwplayer:seek');
};

const _onSeeked = function _onSeeked() {
  _log('_onSeeked');
  $player.trigger('vs:ui:video:player:jwplayer:seeked');
};

const _onSetupError = function _onSetupError(event: any) {
  _log('_onSetupError');
  $player.trigger('vs:ui:video:player:jwplayer:setupError', [event]);
};

const _onTime = function _onTime(event: { position: number }) {
  const showNextUp = function showNextUp() {
    if (options.video!.creditsStart > 0) {
      const nextupWidth = $('.next-up').outerWidth();
      if (event.position >= options.video!.creditsStart) {
        $player.trigger('vs:ui:video:player:watch_next:toggle');
        $('.next-up').show();
        const overlayRight = $('.next-up').css('right');
        if (!options.player.animating && overlayRight !== '0px') {
          $('.next-up').css('right', '-' + nextupWidth + 'px');
          options.player.animating = true;
          $('.next-up').animate({
            right: '0',
          }, 400, () => {
            options.player.animating = false;
          });
        }
      } else {
        $('.next-up').hide();
      }
    }
  };

  // NOTE: 2020Q1_REVAMP_NOTE log can only accept 1 argument.
  _log('_onTime' /*, event */);
  $player.trigger('vs:ui:video:player:jwplayer:time', [event]);

  showNextUp();
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _onCaptionsChanged = function _onCaptionsChanged(_event: any) {
  // NOTE: 2020Q1_REVAMP_NOTE log can only accept 1 argument.
  _log('_onCaptionsChanged' /*, event */);
};

const _showOverlayAppGate = function _showOverlayAppGate() {
  window.ga('send', 'event', 'app-campaign', 'app-gate', options.video!.title);
  $overlayAppGate.removeClass('hidden');
};

const _showOverlayError = function _showOverlayError() {
  _log('Awesomeness averted, no uid / page token.');
  $overlayError.removeClass('hidden');
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _showOverlayPause = function _showOverlayPause(_isReplay?: boolean) {
  if (BrowserDetector.os() === 'AndroidOS' || BrowserDetector.os() === 'iOS') {
    $overlayPause.removeClass('hidden');
  }
};

/**
 * Initialize vs-player
 * @param {Object} videoOptions - containing information needed to setup the player
 * @param {Video} video - Video object that is obtained from the server
 */
const init = function init(videoOptions: VideoPagePlayerOptions, video: Model.Video.Info): void {
  // Initialize player HTML DOM
  $player = $('.video__object__player');
  $cover = $player.find('.video__object__player__cover');
  $coverActions = $player.find('.video__object__player__cover__actions');
  $playBtn = $player.find('.video__object__player__play');
  // Overlays
  $overlayAgeGate = $player.find('.video__object__player__overlay--age-gate');
  $overlayAppGate = $player.find('.video__object__player__overlay--app-gate');
  $overlayDownload = $player.find('.video__object__player__overlay--download');
  $overlayError = $player.find('.video__object__player__overlay--error');
  $overlayPause = $player.find('.video__object__player__overlay--pause');

  // Add on to video options. (TODO: Video options is a global variable. Don't rely on global)
  options.video = video;
  options.playerOptions = videoOptions;

  // Begin player module initialization
  // Make sure video uid is vali
  if (!options.video!.id || !options.playerOptions!.page_token) {
    _showOverlayError();
    return;
  }

  _log('Initialising awesomeness...');

  // Initialize Tracker
  options.videoTracker = new VideoTracker(options.video, options.playerOptions);

  // Determine source
  const getSourcesFn = (options.playerOptions!.hosted === 'true')
    ? webcall.video.getHostedSources
    : webcall.video.getSources
  ;

  // Initialize player with the obtained source
  getSourcesFn({
    video_id: options.video!.id,
    page_token: options.playerOptions!.page_token,
    source: 'web',
  })
    .then((data) => {
      const videoSourcePayload = sourceGenerator.generate(data, options.video!);
      options.video!.source = get(videoSourcePayload, 'sources[0].meta.source');

      return _initJWPlayer(videoSourcePayload);
    })
    .then((jwplayer) => {
      options.videoTracker!.setPlayer(jwplayer);
    });

  // _initBranchLinks();
};

const VSPlayer = {
  init,
  getJwplayerObject() {
    return jwplayerObjectNotifier.get();
  },
};

export default VSPlayer;
